"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sorting = exports.SortOrder = exports.Condition = exports.LogicalConnective = exports.Operator = exports.AuthorizationType = exports.MessageType = exports.createPolicy = exports.Policy = exports.createModel = exports.Model = exports.createApplication = exports.Application = exports.ApplicationContext = exports.onMounted = exports.computed = exports.reactive = exports.ref = exports.defineComponent = exports.default = void 0;
var vue_1 = require("vue");
Object.defineProperty(exports, "computed", { enumerable: true, get: function () { return vue_1.computed; } });
Object.defineProperty(exports, "defineComponent", { enumerable: true, get: function () { return vue_1.defineComponent; } });
Object.defineProperty(exports, "onMounted", { enumerable: true, get: function () { return vue_1.onMounted; } });
Object.defineProperty(exports, "reactive", { enumerable: true, get: function () { return vue_1.reactive; } });
Object.defineProperty(exports, "ref", { enumerable: true, get: function () { return vue_1.ref; } });
var mitt_1 = __importDefault(require("mitt"));
var axios_1 = __importDefault(require("axios"));
var global_1 = require("./global");
Object.defineProperty(exports, "AuthorizationType", { enumerable: true, get: function () { return global_1.AuthorizationType; } });
Object.defineProperty(exports, "LogicalConnective", { enumerable: true, get: function () { return global_1.LogicalConnective; } });
Object.defineProperty(exports, "MessageType", { enumerable: true, get: function () { return global_1.MessageType; } });
Object.defineProperty(exports, "Operator", { enumerable: true, get: function () { return global_1.Operator; } });
Object.defineProperty(exports, "SortOrder", { enumerable: true, get: function () { return global_1.SortOrder; } });
var model_1 = __importDefault(require("./model"));
exports.Model = model_1.default;
var policy_1 = __importDefault(require("./policy"));
exports.Policy = policy_1.default;
var application_1 = __importDefault(require("./application"));
exports.Application = application_1.default;
var utilities_1 = __importDefault(require("./utilities"));
var condition_1 = __importDefault(require("./condition"));
exports.Condition = condition_1.default;
var sorting_1 = __importDefault(require("./sorting"));
exports.Sorting = sorting_1.default;
var ApplicationContext = /** @class */ (function () {
    function ApplicationContext() {
    }
    /**
  * 建立 HTTP 客戶端
  * @param baseURL 基礎網址
  * @param authorized 連線時是否需被授權
  * @param authType 授權類型
  */
    ApplicationContext.createHttpClient = function (baseURL, authorized, authType, certificate) {
        if (authorized === void 0) { authorized = false; }
        if (authType === void 0) { authType = global_1.AuthorizationType.Basic; }
        var client = axios_1.default.create({ baseURL: baseURL });
        if (authorized)
            client.interceptors.request.use(function (config) {
                try {
                    config.headers.Authorization = global_1.AuthorizationType[authType] + " " + certificate(authType || global_1.AuthorizationType.Basic);
                }
                catch (e) {
                    console.log('Failure to generate certificate: ', e);
                    throw e;
                }
                return config;
            });
        client.interceptors.response.use(function (response) {
            var json = response.data || { status: response.statusText, payload: null, message: response.statusText };
            return json.status >= 200 && json.status < 300
                ? Promise.resolve(json)
                : Promise.reject(json);
        }, function (error) {
            var response = error.response || { status: 500, payload: null, message: typeof error === "string" ? error : "System is busy" };
            return Promise.reject(response);
        });
        return client;
    };
    Object.defineProperty(ApplicationContext, "guest", {
        /** 取得來賓(未授權)用戶 */
        get: function () { return this._guest || { Id: 0, Name: 'Guest', PhotoUri: '/resources/guest.png', Permissions: [] }; },
        /** 設定來賓(未授權)用戶 */
        set: function (value) { this._guest = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext.prototype, "guest", {
        /** 取得來賓(未授權)用戶 */
        get: function () { return ApplicationContext.guest; },
        /** 設定來賓(未授權)用戶 */
        set: function (value) { ApplicationContext.guest = value; },
        enumerable: false,
        configurable: true
    });
    ApplicationContext.item = function (key, value, sessional) {
        if (sessional === void 0) { sessional = true; }
        if (typeof localStorage === 'undefined' || localStorage === null)
            return; // server side
        var storage = sessional ? sessionStorage : localStorage;
        if (value === undefined)
            return storage.getItem(key); // get
        else {
            if (value !== null) { // set
                (sessional ? localStorage : sessionStorage).removeItem(key);
                storage.setItem(key, value);
            }
            else { // remove
                sessionStorage.removeItem(key);
                localStorage.removeItem(key);
            }
        }
    };
    ApplicationContext.prototype.item = function (key, value, sessional) {
        if (sessional === void 0) { sessional = true; }
        if (value === undefined)
            return ApplicationContext.item(key); // get
        else {
            if (value !== null)
                ApplicationContext.item(key, value, sessional); // set
            else
                ApplicationContext.item(key, null); // remove
        }
    };
    Object.defineProperty(ApplicationContext, "root", {
        /** 啟始的應用程式 */
        get: function () { return this._applications.length ? ApplicationContext._applications[0] : undefined; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext.prototype, "root", {
        /** 啟始的應用程式 */
        get: function () { return ApplicationContext.root; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext, "current", {
        /** 目前的應用程式 */
        get: function () {
            var _a;
            var id = (_a = vue_1.getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.appContext.config.globalProperties.$id;
            return id !== undefined ? this.getApplication(id) : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext.prototype, "current", {
        /** 目前的應用程式 */
        get: function () { return ApplicationContext.current; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext, "user", {
        /** 目前用戶 */
        get: function () { return this.root ? this.root.user : this.guest; },
        /** 目前用戶 */
        set: function (value) { if (this.root)
            this.root.user = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext.prototype, "user", {
        /** 目前用戶 */
        get: function () { return ApplicationContext.user; },
        /** 目前用戶 */
        set: function (value) { ApplicationContext.user = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext, "utils", {
        /** 取得公用程式 */
        get: function () { return utilities_1.default; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicationContext.prototype, "utils", {
        /** 取得公用程式 */
        get: function () { return utilities_1.default; },
        enumerable: false,
        configurable: true
    });
    /** 將應用程式推至脈絡中 */
    ApplicationContext.push = function (application) {
        this._applications.forEach(function (e) {
            if (e !== application && e.id === application.id)
                throw new Error('應用程式識別碼重複');
        });
        this._applications.push(application);
        application.model.reloadEnums();
    };
    /** 將應用程式推至脈絡中 */
    ApplicationContext.prototype.push = function (application) { return ApplicationContext.push(application); };
    /** 將應用程式從脈絡中移除 */
    ApplicationContext.remove = function (application) { this._applications.remove(application); };
    /** 將應用程式從脈絡中移除 */
    ApplicationContext.prototype.remove = function (application) { ApplicationContext.remove(application); };
    /** 依識別碼取得應用程式 */
    ApplicationContext.getApplication = function (id) { return ApplicationContext._applications.find(function (e) { return e.id === id; }); };
    /** 依識別碼取得應用程式 */
    ApplicationContext.prototype.getApplication = function (id) { return ApplicationContext.getApplication(id); };
    /**
     * 設定中介程序
     * @param channel 頻道
     * @param middleware 中介程序
     */
    ApplicationContext.setMiddleware = function (channel, middleware) {
        this._middlewares[channel] = middleware;
    };
    /**
     * 設定中介程序
     * @param channel 頻道
     * @param middleware 中介程序
     */
    ApplicationContext.prototype.setMiddleware = function (channel, middleware) {
        ApplicationContext.setMiddleware(channel, middleware);
    };
    /**
     * 設定中介程序
     * @param middlewares 中介程序
     */
    ApplicationContext.setMiddlewares = function (middlewares) {
        for (var _i = 0, _a = Object.entries(middlewares); _i < _a.length; _i++) {
            var _b = _a[_i], channel = _b[0], middleware = _b[1];
            this.setMiddleware(channel, middleware);
        }
    };
    /**
     * 設定中介程序
     * @param middlewares 中介程序
     */
    ApplicationContext.prototype.setMiddlewares = function (middlewares) {
        ApplicationContext.setMiddlewares(middlewares);
    };
    /**
     * 開始訂閱
     * @param channel 頻道
     * @param handler 處理函式
     */
    ApplicationContext.subscript = function (channel, handler) { this._emitter.on(channel, handler); };
    /**
     * 開始訂閱
     * @param channel 頻道
     * @param handler 處理函式
     */
    ApplicationContext.prototype.subscript = function (channel, handler) { ApplicationContext.subscript(channel, handler); };
    /**
     * 取消訂閱
     * @param channel 頻道
     * @param handler 處理函式
     */
    ApplicationContext.unsubscript = function (channel, handler) { this._emitter.off(channel, handler); };
    /**
     * 取消訂閱
     * @param channel 頻道
     * @param handler 處理函式
     */
    ApplicationContext.prototype.unsubscript = function (channel, handler) { ApplicationContext.unsubscript(channel, handler); };
    /**
     * 發送訊息
     * @param channel 頻道
     * @param message 訊息
     */
    ApplicationContext.send = function (channel, message) {
        if (typeof channel !== 'string')
            throw Error('channel parameter must be a string');
        this._emitter.emit(channel, message);
        var action = this._middlewares[channel];
        if (action)
            action(message);
    };
    /**
     * 發送訊息
     * @param channel 頻道
     * @param message 訊息
     */
    ApplicationContext.prototype.send = function (channel, message) { ApplicationContext.send(channel, message); };
    /**
     * 建立領域模型
     * @param modules 模組
     * @param options 選項
     */
    ApplicationContext.prototype.createModel = function (name, modules) {
        return new model_1.default(name, modules);
    };
    /**
     * 建立政策
     * @param model 領域模型
     * @param options 選項
     */
    ApplicationContext.prototype.createPolicy = function (model, options) {
        return new policy_1.default(model, options);
    };
    /**
     * 建立應用程式
     * @param name 名稱
     * @param model 領域模型
     * @param policy 策略方針
     * @param configuration 配置
     */
    ApplicationContext.prototype.createApplication = function (component, model, policy, i18n, options) {
        return new application_1.default(component, model, policy, i18n, options);
    };
    ApplicationContext._applications = [];
    ApplicationContext._emitter = mitt_1.default();
    ApplicationContext._middlewares = {
        info: function (message) {
            var content = 'No content';
            if (typeof message === 'string')
                content = message;
            else if (message.content)
                content = message.content || content;
            console.log("Information: " + content);
        },
        warning: function (message) {
            var content = 'No content';
            if (typeof message === 'string')
                content = message;
            else if (message.content)
                content = message.content;
            alert("Warning: " + content);
        },
        error: function (message) {
            var content = 'No content';
            if (typeof message === 'string')
                content = message;
            else if (message.content)
                content = message.content;
            alert("Error: " + content);
        },
        log: function (message) {
            console.log('log: ', message);
            if (ApplicationContext.root) {
                ApplicationContext.root.model.log(typeof message === 'string' ? { content: message } : message).then(function (_) { return _; }, function (failure) { return console.log('Failure to synchorize server log: ', failure.message); });
            }
        },
        'application.user-changed': function () {
            ApplicationContext.send('info', {
                type: global_1.MessageType.Info,
                subject: '用戶變更通知',
                content: ApplicationContext.user ? "\u76EE\u524D\u7528\u6236\u8B8A\u66F4\u70BA\"" + ApplicationContext.user.Name + "\"" : "用戶已登出"
            });
        },
        'application.error': function (error) {
            ApplicationContext.send('error', {
                type: global_1.MessageType.Info,
                subject: "\u7CFB\u7D71\u767C\u751F" + (error.status || '未知') + "\u932F\u8AA4",
                content: error.message
            });
        }
    };
    return ApplicationContext;
}());
exports.ApplicationContext = ApplicationContext;
var instance = new ApplicationContext();
exports.default = instance;
global.CloudFun = instance;
var createModel = instance.createModel;
exports.createModel = createModel;
var createPolicy = instance.createPolicy;
exports.createPolicy = createPolicy;
var createApplication = instance.createApplication;
exports.createApplication = createApplication;
